(() => {
  const ROOT_SELECTOR = '[data-fk-solutions-gallery]';
  const FILTER_KEYS = {
    venue: ['filterVenue', 'filterVenueLabel'],
    budget: ['filterBudget', 'filterBudgetLabel'],
    location: ['filterLocation', 'filterLocationLabel'],
    type: ['filterType', 'filterTypeLabel']
  };

  function initialiseGallery(root) {
    if (!root || root.dataset.solutionsGalleryInitialised === 'true') return;

    const cards = Array.from(root.querySelectorAll('[data-project-card]'));
    const filters = Array.from(root.querySelectorAll('[data-project-filter]'));
    const filtersContainer = root.querySelector('[data-project-filters]');
    const grid = root.querySelector('[data-solutions-grid]');
    const pagination = root.querySelector('[data-solutions-pagination]');
    const pages = root.querySelector('[data-solutions-pages]');
    const previousButton = root.querySelector('[data-solutions-previous]');
    const nextButton = root.querySelector('[data-solutions-next]');
    const status = root.querySelector('[data-project-status]');
    const emptyMessage = root.querySelector('[data-project-empty]');
    const pageSize = Math.max(1, Number(root.dataset.pageSize) || 6);
    const itemSingular = root.dataset.itemSingular || 'guide';
    const itemPlural = root.dataset.itemPlural || 'guides';

    if (!cards.length || !grid || !pagination || !pages || !previousButton || !nextButton) return;

    root.dataset.solutionsGalleryInitialised = 'true';
    let filteredCards = cards;
    let currentPage = 0;

    function populateFilters() {
      filters.forEach((select) => {
        const key = select.dataset.projectFilter;
        const dataKeys = FILTER_KEYS[key];
        const wrapper = root.querySelector(`[data-filter-wrapper="${key}"]`);
        if (!dataKeys) return;

        const options = new Map();
        cards.forEach((card) => {
          const value = card.dataset[dataKeys[0]];
          const label = card.dataset[dataKeys[1]];
          if (value && label && !options.has(value)) options.set(value, label);
        });

        if (options.size < 2) {
          select.disabled = true;
          if (wrapper) wrapper.hidden = true;
          return;
        }

        Array.from(options.entries())
          .sort((first, second) => first[1].localeCompare(second[1]))
          .forEach(([value, label]) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = label;
            select.appendChild(option);
          });
      });

      if (filtersContainer) {
        filtersContainer.hidden = !filters.some((select) => !select.disabled);
      }
    }

    function cardMatchesFilters(card) {
      return filters.every((select) => {
        if (select.disabled || !select.value || select.value === 'all') return true;
        const dataKeys = FILTER_KEYS[select.dataset.projectFilter];
        return dataKeys && card.dataset[dataKeys[0]] === select.value;
      });
    }

    function renderPagination(pageCount) {
      pages.replaceChildren();
      const pageLabel = root.dataset.pageLabel || 'Go to guide page';

      for (let index = 0; index < pageCount; index += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fk-solutions-gallery__page';
        button.dataset.solutionsPage = String(index);
        button.textContent = String(index + 1);
        button.setAttribute('aria-label', `${pageLabel} ${index + 1}`);
        if (index === currentPage) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => showPage(index));
        pages.appendChild(button);
      }

      previousButton.disabled = currentPage === 0;
      nextButton.disabled = currentPage === pageCount - 1;
      pagination.hidden = pageCount <= 1;
    }

    function showPage(pageIndex) {
      const pageCount = Math.max(1, Math.ceil(filteredCards.length / pageSize));
      currentPage = Math.min(pageCount - 1, Math.max(0, pageIndex));
      const firstVisibleIndex = currentPage * pageSize;
      const lastVisibleIndex = Math.min(firstVisibleIndex + pageSize, filteredCards.length);
      const visibleCards = new Set(filteredCards.slice(firstVisibleIndex, lastVisibleIndex));

      cards.forEach((card) => {
        card.hidden = !visibleCards.has(card);
      });

      const count = filteredCards.length;
      grid.hidden = count === 0;
      if (emptyMessage) emptyMessage.hidden = count !== 0;
      if (status) {
        status.textContent = count === 0
          ? `No ${itemPlural} shown`
          : `Showing ${firstVisibleIndex + 1} to ${lastVisibleIndex} of ${count} ${count === 1 ? itemSingular : itemPlural}`;
      }

      renderPagination(pageCount);
    }

    function applyFilters() {
      filteredCards = cards.filter(cardMatchesFilters);
      currentPage = 0;
      showPage(0);
    }

    filters.forEach((select) => select.addEventListener('change', applyFilters));
    previousButton.addEventListener('click', () => showPage(currentPage - 1));
    nextButton.addEventListener('click', () => showPage(currentPage + 1));

    root.addEventListener('shopify:block:select', (event) => {
      const selectedCard = event.target.closest('[data-project-card]');
      const selectedIndex = filteredCards.indexOf(selectedCard);
      if (selectedIndex >= 0) showPage(Math.floor(selectedIndex / pageSize));
    });

    populateFilters();
    applyFilters();
  }

  function initialiseAll(scope) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) initialiseGallery(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initialiseGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
